import * as Yup from 'yup'
import { priceSchema } from 'utils/form'
import { ORDER_APPROVE_FOR_FULFILLMENT } from 'context/auth'

export const INITIAL_ORDER_APPROVE_PROPERTIES_VALUES = {
  percent: 10,
  maxValue: {
    amount: 0,
    currencyCode: 'PLN'
  },
}

export const INITIAL_VALUES = {
  name: '',
  privileges: [],
  orderApproveProperties: INITIAL_ORDER_APPROVE_PROPERTIES_VALUES
}

export const createValidationSchema = () =>
  Yup.object().shape({
    name: Yup.string()
      .required()
      .min(2)
      .max(60),
    privileges: Yup.array()
      .of(Yup.string())
      .required(),
    orderApproveProperties: Yup.object()
      .when('privileges', {
        is: privileges => privileges.includes(ORDER_APPROVE_FOR_FULFILLMENT),
        then: Yup.object().shape({
          percent: Yup.number()
            .required()
            .min(1)
            .max(1000000000),
          maxValue: priceSchema
        })
      })
  })

export function toFormValues (group) {
  const { name, privileges, orderApproveProperties } = group
  return ({
    name,
    privileges: privileges.map(p => p.privilege),
    orderApproveProperties: orderApproveProperties ? orderApproveProperties : INITIAL_ORDER_APPROVE_PROPERTIES_VALUES
  })
}
